<template>
  <div class="resetPassword">
    <Test></Test>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Test from './components/index.vue';

export default {
  name: 'resetPassword',
  data() {
    return {};
  },
  components: {
    Test,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },

  methods: {
    ...mapMutations('publicPage', ['updateState']),

  },
};
</script>
<style scoped></style>
